import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
import { pullConfig, pullPlayerData } from './redux/actions/uiActions';
import { getUrlElement, pullQueryString } from './utils/common';
import SocketContextProvider from './contexts/SocketContextProvider';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setPage } from './redux/actions/commonActions';
import NotFound from './containers/NotFound/NotFound';

// Custom component to dispatch action on mount
const InitApp = () => {
    const dispatch = useDispatch();
    const location = useLocation(); // Hook to get current path

    const [loading, setLoading] = useState(true); // Track CSS loading
    const [isValidConfig, setIsValidConfig] = useState(true);

    // Mapping array for lang codes
    const langMap = {
        "in": "en-IN",
        "kz": "kk",
        "sc": "zh-Hans",
        "kr": "ko-KR",
        "vn": "vi",
        "np": "ne",
        "ch": "zh-Hant",
        "bd": "bn-BD",
        "pk": "en-PK",
        "eu": "en",
        // Add more mappings as needed
    };

    let pageType = 'chat';
    let lang = getUrlElement(3);
    let brand = getUrlElement(4);
    const s = pullQueryString('s');
    const proactive = pullQueryString('proactive');
    dispatch(setPage(''));

    if (brand === "mc-desktop") {
        brand = "dafabet";
    }
    if (lang === "call") {
        lang = pullQueryString('lang');
        pageType = 'call';
    }

    // Check if the lang value exists in the mapping array, if so, map it.
    if (langMap[lang]) {
        lang = langMap[lang];
    }

    const data = {
        brand,
        lang
    };

    useEffect(() => {
        const loadBrandCSS = (brand) => {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = `${process.env.PUBLIC_URL}/css/${brand}.css`;
            document.head.appendChild(link);

            link.onload = () => setLoading(false);
            // Cleanup: Remove the link element when the component unmounts or brand changes
            return () => {
                document.head.removeChild(link);
            };
        };

        const removeBrandCSS = loadBrandCSS(brand);
        return removeBrandCSS; // Cleanup when brand changes
    }, [brand]);


    useEffect(() => {
        const loadBrandFavicon = (brand) => {
            const link = document.createElement('link');
            link.rel = 'icon';
            link.href = `/favicons/${brand}.ico`;
            if (brand==='nextbet' && lang==='pt') {
                link.href = `/favicons/nextbet-brazil.ico`;
            }
            link.type = 'image/x-icon';
            document.head.appendChild(link);

            return () => {
                document.head.removeChild(link);
            };
        };

        const removeBrandFavicon = loadBrandFavicon(brand);
        return removeBrandFavicon;
    }, [brand]);

    React.useEffect(() => {
        // dispatch(pullConfig(data, pageType));
        
        const fetchConfig = async () => {
            const configData = await dispatch(pullConfig(data, pageType));
            if (!configData) {
                setIsValidConfig(false); // Mark as invalid config if no data is returned
            }
            setLoading(false);
        };
    
        fetchConfig();
    }, [dispatch, data]);

    useEffect(() => {
        if(s) {
            dispatch(pullPlayerData(s, brand));
        }
        
    }, [dispatch, s]);

    // Check if the route is for '/call/:brand' and hide the header for this route
    const showHeader = !location.pathname.startsWith('/call');
    
    if (loading) {
        return <div className="loading-spinner">Loading...</div>;
    }

    return isValidConfig ? <App showHeader={showHeader} /> : <NotFound />;
};

// Root rendering
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <SocketContextProvider>
                <Router>
                    <InitApp />
                </Router>
            </SocketContextProvider>
        </Provider>
    </React.StrictMode>
);